import styled from 'styled-components'
import { Colors, Inset } from '@doordash/design-language'

export const ImageContainer = styled.div`
  svg {
    width: 100%;
  }
`

type SectionImageHeaderProps = {
  imageUrl: string
}

export const SectionImageHeader = styled<SectionImageHeaderProps, 'div'>('div')`
  background-image: url(${(props: SectionImageHeaderProps) => props.imageUrl});
  width: 100%;
  min-height: 222px;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
`

export const BulletList = styled.ul`
  color: ${Colors.SystemGrey80};
  padding-left: 16px;
`
export const SlideButtonContainer = styled.div`
  display: flex;
  justify-content: space-between;
`
export const ProgressContainer = styled(Inset)`
  display: flex;
  justify-content: space-around;
`
export const ModalContentPadding = styled.div`
  padding: 16px;
`
